export default {
  namespaced: true,
  state: {
    accolades: [
      {
        title: "2023 Michigan Taxidermist Association",
        pictures: [
          {
            title: "Professional Division",
            src: require("../../assets/accolades/2023_michigan_1.jpg"),
            list: [
              { text: "Best of Category" },
              { text: "Public's Choice Bird" },
              { text: "Matuska Award" },
            ],
          },
        ],
      },
      {
        title: "2023 Ohio Taxidermists Association",
        pictures: [
          {
            title: "Professional Division",
            src: require("../../assets/accolades/2023_ohio_1.jpg"),
            list: [
              { text: "Best of Category" },
              { text: "Best Professional Division Entry" },
              { text: "Matuska Award" },
            ],
          },
        ],
      },
      {
        title: "2023 Association of Indiana Taxidermists",
        pictures: [
          {
            title: "Professional Division",
            src: require("../../assets/accolades/2023_indiana_1.jpg"),
            list: [
              { text: "Best of Category" },
              { text: "McKenzie Taxidermy Supply Choice Bird" },
              { text: "Ducks Unlimited Award" },
              { text: "Most Artistic Habitat" },
              { text: "Life Tone Award" },
              { text: "Habitat Design & Composition Award" },
              { text: "Public's Choice Bird" },
              { text: "Matuska Award" },
            ],
          },
        ],
      },
      {
        title: "2022 The Lakes Magazine - October Issue",
        pictures: [
          {
            title: "",
            subtitle: "",
            src: require("../../assets/accolades/2022_the_lakes_cover.png"),
            links: [
              {
                text: "Read Magazine Article",
                url:
                  "https://issuu.com/tombritt/docs/thelakeseast_1022-issuu/18",
              },
            ],
          },
        ],
      },
      {
        title: "2022 Michigan Taxidermist Association",
        pictures: [
          {
            title: "Chelsea Taxidermy",
            subtitle: "Sponsored Award",
            src: require("../../assets/accolades/2022_michigan.jpg"),
          },
        ],
      },
      {
        title: "2022 Ohio Taxidermists Association",
        pictures: [
          {
            title: "Best of Category",
            src: require("../../assets/accolades/2022_ohio.jpg"),
          },
        ],
      },
      {
        title: "2022 Association of Indiana Taxidermists",
        pictures: [
          {
            title: "President's Challenge",
            subtitle: "Mother's Love",
            src: require("../../assets/accolades/2022_indiana.jpg"),
          },
        ],
      },
      {
        title: "2021 Michigan Taxidermist Association",
        pictures: [
          {
            title: "Hen Buffle Head",
            src: require("../../assets/accolades/2021_michigan_1.jpg"),
          },
          {
            title: "Pheasant",
            src: require("../../assets/accolades/2021_michigan_2.jpg"),
          },
          {
            title: "Hooded Merganzer",
            src: require("../../assets/accolades/2021_michigan_3.jpg"),
          },
        ],
      },
      {
        title: "2021 Ohio Taxidermists Association",
        pictures: [
          {
            title: "Coyote",
            subtitle: "Best Amateur Habitat",
            src: require("../../assets/accolades/2021_ohio_1.jpg"),
          },
          {
            title: "Red Head",
            src: require("../../assets/accolades/2021_ohio_2.jpg"),
          },
          {
            title: "Hooded Merganzer",
            src: require("../../assets/accolades/2021_ohio_3.jpg"),
          },
        ],
      },
      {
        title: "2021 Association of Indiana Taxidermists",
        pictures: [
          {
            title: "Hooded Merganzers",
            subtitle: "Best Amateur Bird",
            src: require("../../assets/accolades/2021_indiana_1.jpg"),
          },
          {
            title: "Red Head",
            src: require("../../assets/accolades/2021_indiana_2.jpg"),
          },
          {
            title: "Ring Neck",
            src: require("../../assets/accolades/2021_indiana_3.jpg"),
          },
          {
            title: "Wood Ducks",
            src: require("../../assets/accolades/2021_indiana_4.jpg"),
          },
          {
            title: "Pheasant",
            src: require("../../assets/accolades/2021_indiana_5.jpg"),
          },
        ],
      },
    ],
  },
  getters: {},
  mutations: {},
  actions: {},
};
